// extracted by mini-css-extract-plugin
module.exports = {"v-slider":"v-slider_v-slider_3zn4s","content":"v-slider_content_MoNlJ"};